import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Sidebar from './Sidebar'
import ErrorBoundary from '../ErrorBoundary'
import ImpersonationBanner from './ImpersonationBanner'
import FeedbackButton from './FeedbackButton'

const Dashboard = lazy(() => import('../../pages/Dashboard'))
const CatalogPage = lazy(() => import('../../pages/Catalog'))
const ClientsPage = lazy(() => import('../../pages/Clients'))
const ScopesPage = lazy(() => import('../../pages/Scopes'))
const ScopeDetailPage = lazy(() => import('../../pages/ScopeDetail'))
const ScopeNewPage = lazy(() => import('../../pages/ScopeNew'))
const UsersPage = lazy(() => import('../../pages/Users'))
const SettingsPage = lazy(() => import('../../pages/Settings'))
const IntegrationsPage = lazy(() => import('../../pages/Integrations'))
const ProductsPage = lazy(() => import('../../pages/Products'))
const ReviewsPage = lazy(() => import('../../pages/Reviews'))

function PageSpinner() {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  )
}

export default function AppShell() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <ImpersonationBanner />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* pb-20 (not p-5's default) reserves room below the last in-flow
              element so the fixed FeedbackButton can never sit on top of a
              page's own bottom content (e.g. Settings' SaveBar) -- found
              live on the Settings page, where SaveBar sat close enough to
              the viewport bottom for the two to overlap. */}
          <main className="flex-1 overflow-y-auto p-5 pb-20">
            <ErrorBoundary>
              <Suspense fallback={<PageSpinner />}>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/catalog/*" element={<CatalogPage />} />
                  <Route path="/clients/*" element={<ClientsPage />} />
                  <Route path="/scopes" element={<ScopesPage />} />
                  <Route path="/scopes/new" element={<ScopeNewPage />} />
                  <Route path="/scopes/:id/*" element={<ScopeDetailPage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/integrations/*" element={<IntegrationsPage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/reviews" element={<ReviewsPage />} />
                </Routes>
              </Suspense>
            </ErrorBoundary>
          </main>
        </div>
      </div>
      <FeedbackButton />
    </div>
  )
}
